import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { Suspense } from "react";
import Test from "./Components/Test";
import Testnew from "./Components/Testnew";
import Memo from "./Components/Memo";
import SingleAlbum from "./Components/SingleAlbum";
import GalleryView from "./Components/GalleryView";
import ProfileView from "./Components/ProfileView";
import GalleryInviteView from "./Components/GalleryInviteView";
import GalleryViewShortLink from "./Components/GalleryViewShortLink";

function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading</div>}>
        <Routes>
          {/* Role Managment Routes */}
          <Route path="/" element={<Memo />} />
          <Route path="/gallery/:galleryId" element={<GalleryView />} />
          {/* Before /:userId — otherwise /view and /share are captured as usernames */}
          <Route path="/view/:shortCode" element={<GalleryViewShortLink />} />
          <Route path="/p/:userId" element={<ProfileView />} />
          <Route path="/galleryInvite" element={<GalleryInviteView />} />
          <Route path="/album" element={<SingleAlbum />} />
          <Route path="/test" element={<Testnew />} />
          <Route path="/:userId" element={<Test />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
